var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.002 2C15.43 2 2 15.43 2 32s13.43 30 30.001 30C48.57 62 62 48.57 62 32S48.57 2 32.002 2zm0 57.5C16.837 59.5 4.5 47.164 4.5 32S16.837 4.5 32.002 4.5C47.164 4.5 59.5 16.836 59.5 32S47.164 59.5 32.002 59.5z",
    fill: "#9E9E9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.271 27.793c.479.506 1.438-.424 1.254-.938c-1.859-5.111-4.66-7.67-7.461-7.67c-2.8 0-5.601 2.559-7.459 7.67c-.184.514.774 1.443 1.254.938c1.802-1.9 3.958-2.658 6.206-2.658c2.249 0 4.406.758 6.206 2.658",
    fill: "#9E9E9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.934 19.186c-2.801 0-5.602 2.559-7.461 7.67c-.184.514.775 1.443 1.254.938c1.803-1.9 3.957-2.658 6.207-2.658s4.404.758 6.207 2.658c.479.506 1.438-.424 1.254-.938c-1.86-5.112-4.661-7.67-7.461-7.67",
    fill: "#9E9E9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.178 35.984C43.715 35.322 38.596 34.64 32 34.64h-.002c-6.594 0-11.713.682-15.176 1.344c-1.35.258-1.822 1.264-1.822 2.067c0 7.271 5.612 14.59 16.999 14.59H32c11.389 0 17-7.318 17-14.59c0-.803-.473-1.809-1.822-2.067m-1.203 3.786c-.055.443-.137.975-.266 1.553c-.141.641-.262.936-1.266.816c-1.92-.229-22.967-.229-24.887 0c-1.004.119-1.123-.176-1.266-.816a16.671 16.671 0 0 1-.265-1.553c-.09-.742-.011-1.268 1.283-1.486c2.195-.367 6.838-1.012 12.691-1.012s10.496.645 12.691 1.012c1.294.218 1.374.743 1.285 1.486",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojis);
export default __webpack_public_path__ + "static/media/emojis.7e8c97a1eebdb0e29f86135c58c292dd.svg";
export { ForwardRef as ReactComponent };